// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Tooltip,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

function AllDataCapturesPage() {
  const pageTitle = "Data Captures";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [captures, setCaptures] = useState([]);

  const tableColumns = [
    { Header: "#", accessor: "capture", align: "left" },
    { Header: "Campaign", accessor: "campaign", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Group", accessor: "agent_group", align: "left" },
    { Header: "Supervisor", accessor: "aggregator", align: "left" },
    // { Header: "Campaign Location", accessor: "campaign_location", align: "left" },
    { Header: "GPS", accessor: "location", align: "center" },
    { Header: "Date", accessor: "date", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        agent: row.agent,
        campaign: row.campaign,
        agent_group: row.agent_group,
        aggregator: row.aggregator,
        // campaign_location: row.campaign_location,
        location: (
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://maps.google.com?q=${row.latitude},${row.longitude}`}
          >
            <Icon>location_on</Icon>
          </a>
        ),
        capture: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="info"
              iconOnly
              circular
              onClick={() => {
                navigate(`/data-capture/${row.reference}`);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                visibility
              </Icon>
            </MDButton>
          </MDBox>
        ),
        date: row.date,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/data_captures.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.captures);
            setCaptures(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox
                        pt={0}
                        px={2}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDBox>
                          <MDTypography variant="h6">Data Captures</MDTypography>
                        </MDBox>
                        <MDBox>
                          <Tooltip title="Refresh">
                            <MDButton
                              variant="outlined"
                              color="info"
                              iconOnly
                              onClick={() => {
                                setRefreshPage(!refreshPage);
                              }}
                            >
                              <Icon>replay</Icon>
                            </MDButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: captures }}
                          isSorted
                          entriesPerPage
                          showTotalEntries
                          buttons
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AllDataCapturesPage;
